import splitDeepLink from "~/helpers/aiChat/deepLinkParts";

export const SCHEDULE_PATH = "/produce/production/schedule";

export type ScheduleJobTarget = { jobNumber: number; kind: "job" } | { kind: "unreadable" } | { kind: "other" };

const parseJobNumber = (raw: string | null): number | null => {
	if (raw === null) return null;
	const value = Number(raw.trim());
	return Number.isInteger(value) && value > 0 ? value : null;
};

const parseScheduleJobTarget = (deepLink: string): ScheduleJobTarget => {
	const { pathname, search } = splitDeepLink(deepLink);
	if (pathname !== SCHEDULE_PATH) return { kind: "other" };
	const jobNumber = parseJobNumber(search.get("job"));
	return jobNumber === null ? { kind: "unreadable" } : { jobNumber, kind: "job" };
};

export { parseScheduleJobTarget };
export default parseScheduleJobTarget;
